import { render, staticRenderFns } from "./TribeProfit.vue?vue&type=template&id=15caca60&scoped=true&"
import script from "./TribeProfit.vue?vue&type=script&lang=js&"
export * from "./TribeProfit.vue?vue&type=script&lang=js&"
import style0 from "./TribeProfit.vue?vue&type=style&index=0&id=15caca60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15caca60",
  null
  
)

export default component.exports